import { Button } from '@simplywallst/ui-core/next';

import { getPath } from '@/router/utils';
import { ROUTE_PUBLIC_NARRATIVE_CREATE } from '@/constants/routes';
import { useTracking } from 'react-tracking';
import { usePathname } from '@/hooks/location/usePathname';
import PlusSolid from '@simplywallst/ui-core/icons/PlusSolid';
import { ComponentProps } from 'react';

type Props = {
  companyId: string;
  uniqueSymbol: string;
  variant?: ComponentProps<typeof Button>['variant'];
  size?: ComponentProps<typeof Button>['size'];
};

export const CompanyNarrativesCreateButton = ({
  companyId,
  uniqueSymbol,
  variant = 'secondary',
  size = 'medium',
}: Props) => {
  const { trackEvent } = useTracking();
  const pathname = usePathname();
  return (
    <Button
      variant={variant}
      size={size}
      href={getPath({
        type: ROUTE_PUBLIC_NARRATIVE_CREATE,
        payload: {
          query: { company: companyId, returnPath: pathname },
        },
      })}
      onClick={() => {
        trackEvent({
          action: 'click',
          modifier: 'create',
          companyId,
          uniqueSymbol,
        });
      }}
    >
      <PlusSolid /> Create Narrative
    </Button>
  );
};
